import { render } from "./HandbookArticleEdit.vue?vue&type=template&id=3d99f7d2&scoped=true"
import script from "./HandbookArticleEdit.vue?vue&type=script&lang=js"
export * from "./HandbookArticleEdit.vue?vue&type=script&lang=js"

import "./HandbookArticleEdit.vue?vue&type=style&index=0&id=3d99f7d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d99f7d2"]])

export default __exports__